<!-- 添加物料 -->
<template>
  <div>
    <e-dialog
      class="agreement-dialog"
      dialog-title="添加物料"
      :dialog-type="''"
      :center-dialog-visible="addMaterialVisible"
      :popup-width="'500px'"
      @resetPopupData="cancelHandle"
      @submitPopupData="addMaterialHandle"
    >
      <div>
        <!-- <div class="sub-title">物料分类</div> -->
        <el-form :inline="true" :model="categoryObject" class="search-form">
          <el-form-item label="分类名称">
            <el-input
              v-model="categoryObject.categoryName"
              placeholder="分类名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <eui-btn type="secondary" class="btn reset-btn" @click="handleReset"
              >重置</eui-btn
            >
            <eui-btn type="weak" class="btn" @click="handleSearch"
              >查询</eui-btn
            >
          </el-form-item>
        </el-form>
        <div class="common-purchase-wrap">
          <el-checkbox v-model="searchCategoryChecked" @change="searchCategory"
            >仅查询常采类目</el-checkbox
          >
          <eui-btn
            class="edit-btn"
            type="link"
            @click="handleCommonPurchaseCategory"
            >编辑常采类目</eui-btn
          >
        </div>
        <div class="tree-content">
          <el-tree
            ref="tree"
            show-checkbox
            :check-strictly="true"
            :default-expand-all="false"
            node-key="categoryId"
            :data="categoriesListAlign"
            :props="defaultProps"
            @check="treeCheck"
          ></el-tree>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <eui-btn size="small" @click="cancelHandle">取 消</eui-btn>
      <eui-btn
        class="reset-btn btn"
        :loading="btnLoading"
        size="small"
        type="primary"
        @click="addMaterialHandle"
      >
        确定
      </eui-btn> -->
      </div>
    </e-dialog>
    <addPurchaseCategory
      :add-purchase-category-visible="addPurchaseCategoryVisible"
      :categories-list-align="allCategoriesListByThird"
      :select-category-list="selectCategoryList"
      @cancelAddPurchaseCategoryHandle="cancelAddPurchaseCategoryHandle"
      @addPurchaseCategoryHandle="addPurchaseCategoryHandle"
    ></addPurchaseCategory>
  </div>
</template>

<script>
// import api from '@/api/product-oss-api';
// import api from '@/modules/projectA/api/purchase';
import api from '@/modules/projectA/api/cms-oss/index';
import productApi from '@/modules/projectA/api/product/index';
import addPurchaseCategory from '@/modules/projectA/pages/plan/components/addPurchaseCategory.vue';

import EDialog from '@/modules/projectA/components/common/e-dialog';

export default {
  components: {
    EDialog,
    addPurchaseCategory,
  },
  props: {
    addMaterialVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      btnLoading: false,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'categoryName',
        // label: "label",
      },
      allCategoriesList: [],
      recommendCategory: [],
      needCheckedNodes: [],
      createMemberName: '',
      categoryObject: {
        categoryName: '',
      },

      categoriesListAlign: [],
      addPurchaseCategoryVisible: false,
      searchCategoryChecked: false,
      allCategoriesListByThird: [],
      selectCategoryList: [],
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },

    categoriesList() {
      // return this.mergeTree(this.allCategoriesList, this.recommendCategory);
      const categoriesArr = this.mergeTree(
        this.allCategoriesList,
        this.recommendCategory
      );
      if (categoriesArr && categoriesArr.length !== 0) {
        return this.formatData(categoriesArr);
      }
      return [];
    },
  },
  watch: {
    addMaterialVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          console.log(this.$refs.tree.getCheckedNodes(), '搜索');
          console.log(this.$refs.tree.getCheckedKeys(), '订单');
        });
      }
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        this.userInfo = newVal;
        if (newVal.companyId) {
          this.purchaseAreaCategory();
          this.getData();
          this.createMemberName = newVal.memberName;
        }
      },
    },
    categoriesList: {
      handler(newVal) {
        this.categoriesListAlign = [...newVal];
        console.log(this.categoriesListAlign);
      },
      deep: true,
    },
  },
  methods: {
    getAllParentNodes(val, tree, attr, newArr = []) {
      // 如果搜索关键字为空直接返回源数据
      if (!(tree.length && val)) {
        return tree;
      }
      for (const item of tree) {
        // 匹配到关键字的逻辑
        console.log(item[attr], 'item[attr]');
        if (item[attr] && item[attr].indexOf(val) > -1) {
          // 如果匹配到就在数值中添加记录
          newArr.push(item);
          // 匹配到了就退出循环了此时如果有子集也会一并带着
          continue;
        }
        console.log(item.children, 'item.children');
        // 如果父级节点没有匹配到就看看是否有子集，然后做递归
        if (item.children && item.children.length) {
          // 缓存递归后的子集数组
          const subArr = this.getAllParentNodes(val, item.children, attr);
          // 如果子集数据有匹配到的节点
          if (subArr && subArr.length) {
            // 关键逻辑，缓存父节点同时将递归后的子节点作为新值
            const node = { ...item, children: subArr };
            // 添加进数组
            newArr.push(node);
          }
        }
      }
      return newArr;
    },
    handleSearch() {
      if (!this.categoryObject.categoryName) return;
      let categoriesList = [];
      if (this.searchCategoryChecked) {
        categoriesList = [...this.categoriesListAlign];
      } else {
        categoriesList = [...this.categoriesList];
      }
      // const categoriesList = [...this.categoriesList];
      const filterArr = this.getAllParentNodes(
        this.categoryObject.categoryName,
        categoriesList,
        'categoryName'
      );
      this.categoriesListAlign = filterArr;
    },

    handleReset() {
      // this.categoryObject.categoryName = '';
      // this.categoriesListAlign = [...this.categoriesList];
      this.categoryObject.categoryName = '';
      if (this.searchCategoryChecked) {
        this.searchCategory();
      } else {
        this.categoriesListAlign = [...this.categoriesList];
      }
    },
    async getData() {
      const res = await api.purchaseAreaRecommendCategory();
      console.log(res, 'recommendCategory');
      if (res.status == 200) {
        this.recommendCategory = res.data.categoryList;
      }
    },
    async purchaseAreaCategory() {
      const params = {
        companyId: this.userInfo.purchaseAreaCompanyId,
      };
      const res = await api.purchaseAreaCategory(params);
      if (res.data.categoryList) {
        this.allCategoriesList = res.data.categoryList;
      }
    },
    // 合并树
    mergeTree(target, source) {
      if (!target?.length && !source?.length) {
        return;
      }
      const arr = target.length ? target : source;
      const more = [];
      source.forEach((sNode) => {
        const tNode = arr.find((tn) => tn.categoryId === sNode.categoryId);
        if (!tNode) {
          more.push(sNode);
          return;
        }

        const { children: sChildren, ...props } = sNode;
        Object.assign(tNode, props);
        this.mergeTree(tNode.children, sChildren);
      });
      arr.push(...more);
      return arr;
    },
    formatData(params) {
      const data = params;
      data.map((item) => {
        if (!item.isLeaf) {
          // 只有要children属性就禁止选择 需要修改css 代码
          item.disabled = true;
          // 递归调用 直到没有 children 属性那级
          this.formatData(item.children);
        }
      });
      return data;
    },
    // this.$refs.tree.getCheckedKeys().concat(this.$refs.tree.getHalfCheckedKeys())
    addMaterialHandle() {
      console.log(this.needCheckedNodes, '物料信息');
      this.$emit('getMaterialList', this.needCheckedNodes);
      this.cancelHandle();
    },
    cancelHandle() {
      this.$emit('update:addMaterialVisible', false);
    },
    treeCheck(nodeObj, selectedObj) {
      console.log(nodeObj, selectedObj);
      const { checkedNodes } = selectedObj;
      const needCheckedNodes = checkedNodes.map((item) => ({
        categoryId: item.categoryId,
        categoryName: item.categoryName,
        categoryCode: item.categoryCode,
        purchasePlanAttachmentAOList: [
          {
            attachmentName: '',
            attachmentType: 0,
            // 附件类型1:采购需求主表附件 2:采购需求明细附件
            attachmentUrl: '',
          },
        ],
        budgetaryPrice: '',
        categoryDesc: '',
        expectedArrivalDate: '',
        quantity: '',
        createMemberName: this.createMemberName,
        baseUnitName: '',
        baseUnitNo: '',
      }));
      this.needCheckedNodes = needCheckedNodes;
      console.log(needCheckedNodes, 'needCheckedNodes');
    },

    handleCommonPurchaseCategory() {
      this.assembleCategoryLeft();
      this.addPurchaseCategoryVisible = true;
    },
    cancelAddPurchaseCategoryHandle() {
      this.addPurchaseCategoryVisible = false;
    },
    async addPurchaseCategoryHandle(options) {
      console.log(options);
      const res = await productApi.addPurchaseOftenCategory({
        categoryIds: options,
      });
      if (res.code === '200') {
        this.$message.success('添加成功');
        if (this.searchCategoryChecked) {
          this.searchCategory();
        }
        this.addPurchaseCategoryVisible = false;
      }
    },
    async searchCategory(val) {
      console.log(this.searchCategoryChecked);
      if (this.searchCategoryChecked) {
        const res = await productApi.queryOftenTree();
        if (res.code === '200') {
          this.categoriesListAlign = this.formatData(res.data.children);
        }
      } else {
        this.categoriesListAlign = this.categoriesList;
      }
    },
    // 组装常采分类左侧数据
    async assembleCategoryLeft() {
      this.allCategoriesListByThird = [];
      this.selectCategoryList = [];
      this.allCategoriesListByThird = this.getLastNode(this.categoriesList);

      this.getSelectedCategoryList();
    },
    // getLastNode(node) {
    //   for (let i = 0; i < node.length; i++) {
    //     if (node[i].isLeaf === 1) {
    //       this.allCategoriesListByThird.push(node[i]);
    //     } else {
    //       this.getLastNode(node[i].children);
    //     }
    //   }
    // },
    getLastNode(nodeArray) {
      const stack = [...nodeArray];
      const result = [];

      while (stack.length > 0) {
        const currNode = stack.pop();

        if (currNode.isLeaf === 1) {
          result.push(currNode);
        } else if (currNode.children && currNode.children.length > 0) {
          // 将子节点逆序压入栈中，保证深度优先搜索
          for (let i = currNode.children.length - 1; i >= 0; i--) {
            stack.push(currNode.children[i]);
          }
        }
      }
      // console.log(result);
      return result;
    },
    // 两个数组先去重再合并
    mergeArray(arr1, arr2) {
      // // 已选常采类目去除固定的
      // const tempArr = [];
      // // 保存固定的数组
      // const tempArr2 = [];
      // for (let k = 0; k < arr2.length; k++) {
      //   if (arr2[k].selfDefine !== false) {
      //     tempArr.push(arr2[k]);
      //   } else {
      //     tempArr2.push(arr2[k]);
      //   }
      // }
      // console.log(tempArr);
      // 合并两个数组并去除重复项
      const mergedArray = arr2.concat(arr1);
      const uniqueArray = [];

      for (let i = 0; i < mergedArray.length; i++) {
        let isDuplicate = false;

        // 检查当前元素是否在结果数组中已存在
        for (let j = 0; j < uniqueArray.length; j++) {
          if (mergedArray[i].categoryId === uniqueArray[j].categoryId) {
            isDuplicate = true;
            break;
          }
        }

        // 如果当前元素不在结果数组中，则添加到结果数组中
        if (!isDuplicate) {
          uniqueArray.push(mergedArray[i]);
        }
      }
      // const totalArray = uniqueArray.concat(tempArr2);
      console.log(uniqueArray);
      return uniqueArray;
    },

    async getSelectedCategoryList() {
      const res = await productApi.queryPurchaseOftenCategory();
      if (res.code === '200') {
        this.allCategoriesListByThird = this.mergeArray(
          this.allCategoriesListByThird,
          res.data
        );
        // const tempArr = this.allCategoriesListByThird.concat(res.data);
        // this.allCategoriesListByThird = tempArr;
        res.data.map((item2) => {
          this.selectCategoryList.push(item2.categoryId);
        });
        console.log(this.selectCategoryList);
        this.allCategoriesListByThird.forEach((item) => {
          if (
            this.selectCategoryList.includes(item.categoryId) &&
            (item.selfDefine === false || item.selfDefine === undefined)
          ) {
            item.disabled = true;
            return item;
          }
        });
      }
      // console.log(this.allCategoriesListByThird);
      // console.log(res.data);
    },
  },
};
</script>
<style lang="scss" scoped>
.add-material {
  ::v-deep .el-checkbox__input.is-disabled {
    display: none;
  }
  ::v-deep .el-checkbox.is-disabled {
    margin-right: 0;
  }
  .search-form {
    display: flex;
    justify-content: center;
    ::v-deep .el-form-item {
      display: inline-block;
      margin-right: 10px;
      vertical-align: top;
    }
    ::v-deep .el-input__inner {
      border-radius: 0;
    }
  }
  .search-box {
    background: #fff;
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 10px;
      margin-right: 20px;
    }
    .search-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 16px;

      .btn {
        width: 80px;
        text-align: center;
        height: 30px;
        line-height: 27px;
        cursor: pointer;
      }

      /* .reset-btn {
        background: #e8efff;
        border: 1px solid #2587ff;
        color: #2587ff;
        margin-right: 30px;
        line-height: 27px;
        &:hover,
        :active {
          background-color: #126edf;
          color: #fff;
        }
      }
      .submit-btn {
        background: #2587ff;
        border: 1px solid #2587ff;
        color: #ffffff;
        &:hover,
        :active {
          background-color: #126edf;
        }
      } */
    }
  }
  /* .list-box {
    max-height: 260px;
  } */
}
.common-purchase-wrap {
  margin: 10px 0;
  .edit-btn {
    margin-left: 10px;
  }
}
</style>
